<ng-template ngFor let-notification [ngForOf]="userService.notifications$ | async">
  <ng-container [ngSwitch]="notification.__typename">
    <vnm-fields-required-notification
      *ngSwitchCase="'FieldsRequired'"
      [record]="notification"
    ></vnm-fields-required-notification>
    <vnm-contact-notification *ngSwitchCase="'ContactMethod'" [record]="notification"></vnm-contact-notification>
    <vnm-invite-notification *ngSwitchCase="'Invite'" [record]="notification"></vnm-invite-notification>
    <vnm-impersonation-notification *ngSwitchCase="'User'" [record]="notification"></vnm-impersonation-notification>
    <vnm-persistent-notification *ngSwitchDefault [record]="notification"></vnm-persistent-notification>
  </ng-container>
</ng-template>
